
const breakpoints = {
    mobile: 768, //less than mobile
    //tablet: 1050, //DEPRECATED. EpicGamesNav will now detect if siteNav can't fit and auto hamburgler it
    collapseTarget: 769 //above this threshold will try use collapseTarget instead of assume tablet mode
    //desktop assumed when > mobile
};


module.exports = breakpoints;



/** WEBPACK FOOTER **
 ** ./app/scripts/constants/breakpoints.js
 **/